import React, {useEffect, useState} from 'react'
import styled from 'styled-components'

import closeImg from '/static/images/cookies/close.svg'
import logoImg from '/static/images/cookies/preferences/logo.png'

import Button from '/src/components/library/Button'
import {CloseButton} from "../../../../.cache/fast-refresh-overlay/components/overlay"
import buttonImg from "../../../../static/images/modals/images/close.svg";

const Preferences = ({setModalState, setCookies, cookies, closeModal}) => {
    const [valueStatistics, setValueStatistics] = useState(true)
    const [valueFunctionality, setValueFunctionality] = useState(false)
    const [valueAdvertising, setValueAdvertising] = useState(false)

    useEffect(() => {
    })

    function removeCookies() {
        document.cookie = "ga-disable-G-QZVD2FV8P3=true; expires=Thu, 31 Dec 2099 23:59:59 UTC;path=/";
        window.disableStr = 1;
    }

    return (
        <StyledPreferences>
            <ModalContainer>
                <LogoWrapper>
                    <Logo img={logoImg}/>
                </LogoWrapper>
                <CloseModal onClick={() => closeModal()}/>
                <FirstTextWrapper>
                    <FirstTitleSection>Privacy Preference Center</FirstTitleSection>
                    <TextSection>When you visit any website, it may store or retrieve information on your browser,
                        mostly in
                        the form of cookies. This information might be about your preferences or your device and is
                        mostly
                        used to make the site work as you expect it to. The information does not usually directly
                        identify
                        you, but it can give you a more personalized web experience. Because we respect your right to
                        privacy, you can choose not to allow some types of cookies. However, blocking some types of
                        cookies
                        may impact your experience of the site and the services we are able to offer.</TextSection>
                </FirstTextWrapper>
                <SecondTextWrapper>
                    <SecondTitleSection>Manage Cookie Preferences</SecondTitleSection>
                </SecondTextWrapper>

                <Container>
                    <CookiesPreferences>
                        <Toggle>
                            <Subtitle>Strictly Necessary Cookies</Subtitle>
                            <Active>Always active</Active>
                        </Toggle>
                        <TextWrapper>
                            <Description>These cookies are necessary for the website to function and cannot be switched
                                off in our systems. They are usually only set in response to actions made by you which
                                amount to a request for services, such as setting your privacy preferences, logging in
                                or filling in forms. You can set your browser to block or alert you about these cookies,
                                but some parts of the site will not then work. These cookies do not store any personally
                                identifiable information.</Description>
                        </TextWrapper>
                    </CookiesPreferences>

                    <CookiesPreferences>
                        <Toggle>
                            <Subtitle>Statistics Cookies</Subtitle>
                            <TB>
                                <label className="switch">
                                    <input type="checkbox" checked={valueStatistics}
                                           onClick={() => setValueStatistics(!valueStatistics)}/>
                                    <span className="slider round"></span>
                                </label>
                            </TB>
                        </Toggle>
                        <TextWrapper>
                            <Description>These cookies allow us to count visits and traffic sources so we can measure
                                and
                                improve the performance of our site. They help us to know which pages are the most and
                                least
                                popular and see how visitors move around the site. None of this information can be used
                                to
                                identify you. All information these cookies collect is aggregated and therefore
                                anonymous.
                                If
                                you do not allow these cookies, we will not be able to monitor and optimize the
                                website’s
                                performance.</Description>
                        </TextWrapper>
                    </CookiesPreferences>

                    <CookiesPreferences>
                        <Toggle>
                            <Subtitle>Functionality Cookies</Subtitle>
                            <TB>
                                <label className="switch">
                                    <input type="checkbox" checked={valueFunctionality}
                                           onClick={() => setValueFunctionality(!valueFunctionality)}/>
                                    <span className="slider round"></span>
                                </label>
                            </TB>
                        </Toggle>
                        <TextWrapper>
                            <Description>These cookies enable the website to provide enhanced functionality and
                                personalization by remembering choices you have made in the past. They may be set by us
                                or
                                by third party providers whose services we have added to our pages. If you do not allow
                                these cookies, then some or all of these services may not function
                                properly.</Description>
                        </TextWrapper>
                    </CookiesPreferences>

                    <CookiesPreferences>
                        <Toggle>
                            <Subtitle>Advertising Cookies</Subtitle>
                            <TB>
                                <label className="switch">
                                    <input type="checkbox" checked={valueAdvertising}
                                           onClick={() => setValueAdvertising(!valueAdvertising)}/>
                                    <span className="slider round"></span>
                                </label>
                            </TB>
                        </Toggle>
                        <TextWrapper>
                            <Description>These cookies can track your online activity to help us deliver more relevant
                                advertising or to limit how many times you see an ad. These cookies may be set through
                                our
                                site by our advertising partners. They do not store directly personal information, but
                                are
                                based on uniquely identifying your browser and internet device. If you do not allow
                                these
                                cookies, you will experience less relevant advertising.</Description>
                        </TextWrapper>
                    </CookiesPreferences>
                </Container>

                <ButtonWrapper>
                    <Button secondary type={'submit'} label={'Confirm choices'} onClick={() => {
                        if (!valueStatistics)
                            removeCookies()
                        setCookies(true)
                        setModalState(false)
                    }}/>
                </ButtonWrapper>
            </ModalContainer>
        </StyledPreferences>
    )
}

export default Preferences

const StyledPreferences = styled.div`
  overflow-y: auto;
  height: 80vh;
  //position: relative;
  padding: 4.6rem 4.8rem;
  @media ${({theme}) => theme.breakpoints.mobile} {
    padding: 0;
    &::-webkit-scrollbar {
      display: none;
    }

    -ms-overflow-style: none;
    scrollbar-width: none;
    //margin-top: 12rem;
    //padding-left: 1.4rem;
    //padding-right: 1.4rem;
  }
`

const ModalContainer = styled.div`
  position: relative;
  @media ${({theme}) => theme.breakpoints.mobile} {
    padding-right: 2rem;
    padding-left: 2rem;
  }
`

const Active = styled.span`
  color: #3B869D;
  font-family: Sequel65;
  font-size: 1.4rem;
  line-height: 2rem;
  @media ${({ theme }) => theme.breakpoints.mobile} {
    margin-top: 1.5rem;
  }
`

const CloseModal = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  background-image: url(${closeImg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 2.4rem;
  height: 2.4rem;
`

// const ButtonImage = styled.div`
//   background-image: url(${buttonImg});
//   background-position: center;
//   background-size: contain;
//   background-repeat: no-repeat;
//   width: 2.4rem;
//   height: 2.4rem;
// `

const Container = styled.div`
  div:first-child {
    border-top: unset;
    padding-top: 0;
  }
  div:last-child {
    padding-bottom: 0;
    border-bottom: unset;
  }
`

const CookiesPreferences = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem 0;
  border-bottom: 1px solid #EBEBEB;
  border-top: 1px solid #EBEBEB;
`

const Toggle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media ${({ theme }) => theme.breakpoints.mobile} {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
`

const Subtitle = styled.span`
  font-family: Sequel75;
  font-size: 1.6rem;
  line-height: 4.2rem;
  @media ${({ theme }) => theme.breakpoints.mobile} {
    line-height: 2.2rem;
  }
`

const TB = styled.div`
  @media ${({ theme }) => theme.breakpoints.mobile} {
    margin-top: 1.5rem;
  }
  .switch {
    position: relative;
    display: inline-block;
    width: 54px;
    height: 30px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: 8px;
    bottom: 5px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
  }

  input:checked + .slider {
    background-color: #3B869D;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #3B869D;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(18px);
    -ms-transform: translateX(18px);
    transform: translateX(18px);
  }

  /* Rounded sliders */

  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
`

const Description = styled.p`
  margin-top: 1rem;
  max-width: 55.2rem;
  font-family: Sequel45;
  font-size: 1.2rem;
  color: #959595;
  line-height: 1.8rem;
  @media ${({ theme }) => theme.breakpoints.mobile} {
    margin-top: 1.5rem;
  }
`

const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
`

const Logo = styled.div`
  //margin-top: 4.6rem;
  background-image: url(${logoImg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20rem;
  height: 4.8rem;
`

const TextWrapper = styled.div`
`

const FirstTextWrapper = styled.div`
  margin-top: 4.2rem;
`

const SecondTextWrapper = styled.div`
  margin-top: 2.4rem;
  margin-bottom: 2.4rem;
`

const FirstTitleSection = styled.span`
  margin-top: 4.2rem;
  font-family: Sequel75;
  font-size: 2rem;
`

const SecondTitleSection = styled.span`
  font-family: Sequel75;
  font-size: 2rem;
`

const TextSection = styled.p`
  margin-top: .8rem;
  max-width: 55.2rem;
  font-family: Sequel45;
  font-size: 1.2rem;
`

const ButtonWrapper = styled.div`
  margin-top: 3.4rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`